import axios from 'axios';
import { baseUrl } from './baseUrl';
import { getPartnerToken } from './auth';

// Get all notifications for partner
export const getPartnerNotifications = async (params = {}) => {
    try {
        const token = getPartnerToken();
        const { page = 1, limit = 20, isRead } = params;

        let queryParams = `?page=${page}&limit=${limit}`;
        if (isRead !== undefined) {
            queryParams += `&isRead=${isRead}`;
        }

        const res = await axios.get(`${baseUrl}/partner/notifications${queryParams}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return res.data;
    } catch (err) {
        console.error('Get Partner Notifications Error:', err);
        throw err;
    }
};

// Get notification statistics
export const getNotificationStats = async () => {
    try {
        const token = getPartnerToken();
        const res = await axios.get(`${baseUrl}/partner/notifications/stats`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return res.data;
    } catch (err) {
        console.error('Get Notification Stats Error:', err);
        throw err;
    }
};

// Get notification by ID
export const getNotificationById = async (id) => {
    try {
        const token = getPartnerToken();
        const res = await axios.get(`${baseUrl}/partner/notifications/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return res.data;
    } catch (err) {
        console.error('Get Notification by ID Error:', err);
        throw err;
    }
};

// Mark specific notification as read
export const markNotificationAsRead = async (notificationId) => {
    try {
        const token = getPartnerToken();
        const res = await axios.patch(`${baseUrl}/partner/notifications/mark-read`,
            { notificationId },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return res.data;
    } catch (err) {
        console.error('Mark Notification as Read Error:', err);
        throw err;
    }
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async () => {
    try {
        const token = getPartnerToken();
        const res = await axios.patch(`${baseUrl}/partner/notifications/mark-all-read`, {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return res.data;
    } catch (err) {
        console.error('Mark All Notifications as Read Error:', err);
        throw err;
    }
};

// Delete notification
export const deleteNotification = async (id) => {
    try {
        const token = getPartnerToken();
        const res = await axios.delete(`${baseUrl}/partner/notifications/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return res.data;
    } catch (err) {
        console.error('Delete Notification Error:', err);
        throw err;
    }
};
